import { createTheme } from '@material-ui/core';

declare module '@material-ui/core/styles/createTheme' {
  interface Theme {
    sidebarWidth: number;
    sidebarMobileHeight: number;
    brand: string;
    footerHeight: number;
    mobileTopBarHeight: number;
    mobileFooterHeight: number;
    sidebarMobilePadding: number;
    participantBorderWidth: number;
    rightDrawerWidth: number;
    galleryViewBackgroundColor: string;
  }

  // allow configuration using `createMuiTheme`
  interface ThemeOptions {
    sidebarWidth?: number;
    sidebarMobileHeight?: number;
    brand: string;
    footerHeight: number;
    mobileTopBarHeight: number;
    mobileFooterHeight: number;
    sidebarMobilePadding: number;
    participantBorderWidth: number;
    rightDrawerWidth?: number;
    galleryViewBackgroundColor: string;
  }
}

const defaultTheme = createTheme();

export default createTheme({
  overrides: {
    MuiCssBaseline: {
      '@global': {
        'html, body, #root': {
          height: '100%',
        },
      },
    },
    MuiButton: {
      root: {
        borderRadius: '4px',
        textTransform: 'none',
        //color: 'rgb(40, 42, 43)',
        //color: '#0000FF',
        //background: 'linear-gradient(45deg, #051dff 0, #b500ff 100%)',

        fontSize: '0.9rem',
        transition: defaultTheme.transitions.create(['box-shadow', 'border', 'color'], {
          duration: defaultTheme.transitions.duration.short,
        }),
      },
      text: {
        padding: '6px 14px',
        //color: '#FF00FF',
      },
      containedPrimary: {
        background: 'linear-gradient(45deg, rgba(5, 29, 255, 1), rgba(181, 0, 255, 1) 100%)',
        color: '#FFFFFF',

        '&:disabled': {
          background: 'linear-gradient(45deg, rgba(5, 29, 255, 0.2), rgba(181, 0, 255, 0.2) 100%)',
          color: '#FFFFFF',
        },

        '&:hover': {
          background: 'linear-gradient(45deg, rgba(5, 29, 255, 0.8), rgba(181, 0, 255, 0.8) 100%)',
          //boxShadow: '3px 3px 5px 2px rgba(40, 42, 43, .5)',
          backgroundColor: 'rgba(0, 0, 0, 0)',
        },
      },
      contained: {
        boxShadow: 'none',
        '&:hover': {
          boxShadow: 'none',
        },
        '&.Mui-disabled': {
          color: '#0000FF',
          backgroundColor: 'rgba(0, 255, 0, 0.12)',
          //border: '1px solid rgba(0, 255, 0, 0.12)',
          boxShadow: 'none',
        },
      },
      outlinedPrimary: {
        border: '2px solid #aaa',
        color: 'rgba(0, 0, 0, 0.87)',
        //margin: '1em 0',
        //border: '2px solid rgba(0, 0, 0, 0.25)',
        '&:hover': {
          border: '2px solid #aaa',
          color: 'rgba(0, 0, 0, 0.87)',
          backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
      },
      startIcon: {
        marginRight: '6px',
      },
    },
    MuiTypography: {
      body1: {
        color: 'rgb(40, 42, 43)',
        fontSize: '0.9rem',
      },
    },
    MuiInputBase: {
      root: {
        fontSize: '0.9rem',
      },
    },
    MuiSelect: {
      root: {
        padding: '0.85em',
      },
    },
    MuiDialogActions: {
      root: {
        padding: '16px',
      },
    },
    MuiTextField: {
      root: {
        color: 'rgb(40, 42, 43)',
      },
    },
    MuiInputLabel: {
      root: {
        color: 'rgb(40, 42, 43)',
        fontSize: '1.1rem',
        marginBottom: '0.2em',
        fontWeight: 500,
      },
    },
    MuiOutlinedInput: {
      notchedOutline: {
        borderColor: 'rgb(136, 140, 142)',
      },
    },
  },
  typography: {
    fontFamily: 'Inter, sans-serif',
  },
  palette: {
    primary: {
      main: '#027AC5',
    },
  },
  brand: '#E22525',
  footerHeight: 72,
  mobileFooterHeight: 56,
  sidebarWidth: 300,
  sidebarMobileHeight: 90,
  sidebarMobilePadding: 8,
  participantBorderWidth: 2,
  mobileTopBarHeight: 52,
  rightDrawerWidth: 320,
  galleryViewBackgroundColor: '#121C2D',
});
